import { Container } from "../atoms/Container";
import { IOSDevice } from "../device/IOSDevice";
import { Eyebrow } from "../atoms/Eyebrow";
import { ScreenPlan } from "../screens/ScreenPlan";

type SitePlanProps = {
  mobile?: boolean;
};

const PHASES = [
  "Base · weeks 1–4",
  "Build · 5–9",
  "Peak · 10–14",
  "Taper · 15–17",
  "Race · 18",
];

export function SitePlan({ mobile = false }: SitePlanProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      style={{
        paddingTop: mobile ? 72 : 128,
        paddingBottom: mobile ? 72 : 128,
        background: "var(--surface)",
      }}
    >
      <Container pad={pad}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "minmax(0,7fr) minmax(0,5fr)",
            gap: mobile ? 56 : 96,
            alignItems: "center",
          }}
        >
          <div>
            <Eyebrow style={{ marginBottom: 24 }}>The Plan</Eyebrow>
            <h2
              style={{
                fontFamily: "var(--display)",
                fontSize: mobile ? "clamp(40px, 10vw, 56px)" : "clamp(48px, 5.5vw, 72px)",
                lineHeight: 0.98,
                letterSpacing: "-0.025em",
                fontWeight: 400,
                color: "var(--text)",
                margin: "0 0 32px",
              }}
            >
              Eighteen
              <br />
              chapters.
            </h2>
            <div
              style={{
                fontFamily: "var(--ui)",
                fontSize: mobile ? 16 : 18,
                lineHeight: 1.6,
                color: "var(--text-2)",
                maxWidth: 460,
                display: "flex",
                flexDirection: "column",
                gap: 18,
              }}
            >
              <p style={{ margin: 0 }}>
                The plan reads as eighteen chapters, not a calendar grid. Base, then Build, then
                Peak, then Taper, then Race. Each phase asks something different of you.
              </p>
              <p style={{ margin: 0 }}>
                Cut-back weeks land where the body needs them. The twenty-miler arrives when
                you&apos;re ready for it. Race week is quiet on purpose.
              </p>
            </div>

            <div
              style={{
                marginTop: mobile ? 36 : 56,
                display: "flex",
                flexWrap: "wrap",
                gap: 32,
                fontFamily: "var(--ui)",
                fontSize: 13,
                color: "var(--text-2)",
              }}
            >
              {PHASES.map((s, i) => (
                <div key={s} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <span
                    style={{
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      background: i === 2 ? "var(--accent)" : "var(--text-3)",
                    }}
                  />
                  {s}
                </div>
              ))}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: mobile ? "center" : "flex-end",
              gap: 14,
            }}
          >
            <div
              style={{
                transform: "scale(0.85)",
                transformOrigin: mobile ? "center top" : "right top",
                marginBottom: mobile ? -90 : -100,
              }}
            >
              <IOSDevice width={402} height={780}>
                <ScreenPlan />
              </IOSDevice>
            </div>
            <div
              style={{
                fontFamily: "var(--ui)",
                fontSize: 12,
                color: "var(--text-3)",
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                alignSelf: mobile ? "center" : "flex-end",
                marginRight: mobile ? 0 : 16,
              }}
            >
              From the app · week 11 of 18
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
